var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateCurso',{staticClass:"start",style:(_vm.isLoaded ? 'opacity:1' : 'opacity:0'),attrs:{"curso":_vm.curso,"cursos":_vm.cursosArray,"check-class":_vm.checkClass,"isup":_vm.isup,"on-footer":_vm.onFooter,"tipo":"pos-graduacao"}})}
var staticRenderFns = []

export { render, staticRenderFns }